import { useSyncExternalStore } from 'react'

/*
 * F-155: whether the welcome is in front of the community. "Complete seu
 * cadastro" (F-85) and the other prompts wait while it is, and read again when
 * it ends (`round` changes), so a field the welcome already asked is not asked
 * twice. The "Primeiros passos" card reads again too.
 */
let state = { active: false, round: 0 }
const listeners = new Set<() => void>()
const emit = () => listeners.forEach((listener) => listener())

export const setWelcomeActive = (active: boolean) => {
  if (state.active === active) return
  state = { active, round: active ? state.round : state.round + 1 }
  emit()
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

export const useWelcomeActive = () => useSyncExternalStore(subscribe, () => state.active)
/** Grows each time a welcome ends: a dependency for whatever should read again after it. */
export const useWelcomeRound = () => useSyncExternalStore(subscribe, () => state.round)
